import React, { useState } from "react";
import { Modal, Container, Form, Button, Dropdown } from "react-bootstrap";

const ContactUploadSelectModal = ({
  contactData,
  carrierData, // <-- renamed from carrierData for clarity
  show,
  setShow,
  selectedContactIds, // <-- renamed from selectedCarrierIds
  setSelectedContactIds, // <-- renamed from setSelectedCarrierIds
  handleContactTemplateDownload,
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [searchText, setSearchText] = useState("");
  const filteredContacts = contactData
    .filter((contact) =>
      (contact.name || "").toLowerCase().includes(searchText.toLowerCase()),
    )
    .sort((a, b) => (a.name || "").localeCompare(b.name || ""));
  console.log("contactData in modal:", contactData);

  return (
    <Container>
      <Modal
        centered
        dialogClassName="custom-modal"
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        scrollable
        show={show}
        onHide={() => {
          setSelectedContactIds([]);
          setSearchText("");
          setShow(false);
        }}
        style={{ minHeight: "80vh" }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Select Contacts to Include</Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{ minHeight: "400px", maxHeight: "60vh", overflowY: "auto" }}
        >
          <Form.Group>
            <Form.Label>Contacts</Form.Label>
            <Dropdown
              show={dropdownOpen}
              onToggle={() => setDropdownOpen(!dropdownOpen)}
            >
              <Dropdown.Toggle
                variant="outline-secondary"
                id="contact-multiselect-dropdown"
                style={{ width: "100%", textAlign: "left" }}
              >
                {selectedContactIds.length === 0
                  ? "Select contacts..."
                  : contactData
                      .filter((c) => selectedContactIds.includes(c.id))
                      .map((c) => c.name)
                      .join(", ")}
              </Dropdown.Toggle>
              <Dropdown.Menu
                style={{ maxHeight: 300, overflowY: "auto", width: "100%" }}
              >
                <Form.Select
                  aria-label="Select Carrier"
                  style={{ margin: "0.5rem" }}
                  onChange={(e) => {
                    const carrierId = e.target.value;
                    if (carrierId) {
                      // Select all contacts for this carrier
                      const contactIds = contactData
                        .filter(
                          (contact) => String(contact.carrierId) === carrierId,
                        )
                        .map((contact) => contact.id);
                      setSelectedContactIds(contactIds);
                      // Optionally, trigger download immediately:
                      // handleContactTemplateDownload(contactIds);
                    } else {
                      setSelectedContactIds([]);
                    }
                  }}
                  defaultValue=""
                >
                  <option value="" disabled>
                    Download all contacts by carrier...
                  </option>
                  {[...carrierData]
                    .filter((carrier) =>
                      contactData.some(
                        (contact) => contact.carrierId === carrier.id,
                      ),
                    )
                    .sort((a, b) => a.carrierName.localeCompare(b.carrierName))
                    .map((carrier) => (
                      <option key={carrier.id} value={carrier.id}>
                        {carrier.carrierName}
                      </option>
                    ))}
                </Form.Select>
                <Form.Control
                  type="text"
                  placeholder="Search contacts..."
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  style={{ margin: "0.5rem" }}
                  autoFocus
                />
                <Form.Check
                  type="checkbox"
                  id="select-all-contacts"
                  label="Select All"
                  style={{ marginLeft: "1rem", marginBottom: "0.5rem" }}
                  checked={
                    filteredContacts.length > 0 &&
                    filteredContacts.every((contact) =>
                      selectedContactIds.includes(contact.id),
                    )
                  }
                  ref={(el) => {
                    if (el) {
                      el.indeterminate =
                        filteredContacts.some((contact) =>
                          selectedContactIds.includes(contact.id),
                        ) &&
                        !filteredContacts.every((contact) =>
                          selectedContactIds.includes(contact.id),
                        );
                    }
                  }}
                  onChange={(e) => {
                    if (e.target.checked) {
                      // Add all filtered contact IDs
                      const newIds = [
                        ...new Set([
                          ...selectedContactIds,
                          ...filteredContacts.map((contact) => contact.id),
                        ]),
                      ];
                      setSelectedContactIds(newIds);
                    } else {
                      // Remove all filtered contact IDs
                      const newIds = selectedContactIds.filter(
                        (id) => !filteredContacts.map((c) => c.id).includes(id),
                      );
                      setSelectedContactIds(newIds);
                    }
                  }}
                />
                {[...contactData]
                  .filter((contact) =>
                    (contact.name || "")
                      .toLowerCase()
                      .includes(searchText.toLowerCase()),
                  )
                  .sort((a, b) => (a.name || "").localeCompare(b.name || ""))
                  .map((contact) => {
                    const carrierName =
                      carrierData.find((c) => c.id === contact.carrierId)
                        ?.carrierName || "";
                    return (
                      <Form.Check
                        key={contact.id}
                        type="checkbox"
                        id={`contact-checkbox-${contact.id}`}
                        label={`${contact.name}${carrierName ? " - " + carrierName : ""}`}
                        checked={selectedContactIds.includes(contact.id)}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedContactIds([
                              ...selectedContactIds,
                              contact.id,
                            ]);
                          } else {
                            setSelectedContactIds(
                              selectedContactIds.filter(
                                (id) => id !== contact.id,
                              ),
                            );
                          }
                        }}
                        style={{ marginLeft: "1rem", marginRight: "1rem" }}
                      />
                    );
                  })}
              </Dropdown.Menu>
            </Dropdown>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setSelectedContactIds([]);
              setSearchText("");
              setShow(false);
            }}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              setSelectedContactIds([]);
              handleContactTemplateDownload();
              setSearchText("");
              setShow(false);
            }}
          >
            Download
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default ContactUploadSelectModal;
